import { useState } from 'react';

import { cn } from '@/lib/utils';

export const SITE_NAME = 'HUNK';
/** the HUNK logo (transparent PNG) - apps/client/public/logo.png */
const LOGO_SRC = '/logo.png';

/** site logo image; falls back to a red "HUNK" word mark while public/logo.png is missing */
export function Logo({ className, size = 'md' }: { className?: string; size?: 'md' | 'lg' }) {
  const [missing, setMissing] = useState(false);
  if (!missing) {
    return (
      <img
        src={LOGO_SRC}
        alt={SITE_NAME}
        onError={() => setMissing(true)}
        className={cn('w-auto select-none object-contain', size === 'lg' ? 'h-24' : 'h-10 md:h-14', className)}
        draggable={false}
      />
    );
  }
  return (
    <span className={cn('inline-flex flex-col items-center leading-none select-none', className)}>
      <span
        className={cn('text-primary font-black tracking-tighter italic', size === 'lg' ? 'text-6xl' : 'text-3xl md:text-4xl')}
        style={{ textShadow: '2px 2px 0 #000, 3px 3px 0 #7a1015' }}
      >
        HUNK
      </span>
      <span className={cn('text-white/80 font-semibold', size === 'lg' ? 'mt-1 text-sm' : 'text-[9px] md:text-[10px]')}>בבעלות הבוס הגדול</span>
    </span>
  );
}
